
export default () => {

    const galleries = document.querySelectorAll('.config-wrapper')
    const navs = document.querySelectorAll('.config-navigation-item')

    if(!Array.from(galleries).length || !Array.from(navs).length) return

    const setInactive = _ => {
        [...galleries, ...navs].forEach(el => el.classList.remove('active'))
    }

    const setActive = id => {

        setInactive()

        const item = document.querySelector(`.config-wrapper[data-list="${id}"]`)
        const navWrapper = document.querySelector(`.config-navigation-item[data-nav="${id}"]`)

        item.classList.add('active')
        navWrapper.classList.add('active')
    }

    const setup = gallery => {
        const id = gallery.dataset.list
        const container = gallery.querySelector('.config-viewport')
        const navWrapper = document.querySelector(`.config-navigation-item[data-nav="${id}"]`)
        const navContainer = navWrapper.querySelector('.config-navigation-options')

        const items = 1
        const controls = false

        navWrapper.addEventListener('click', () => {
            setActive(id)
        })

        tns({
            container,
            controls,
            items,
            navContainer
        })
    }

    galleries.forEach(setup)

    setActive('main')
}
